(function () {
  'use strict';

  var root = document.querySelector('[data-rm-quiz]');
  var bank = Array.isArray(window.CCRoyalMarinesQuizBank) ? window.CCRoyalMarinesQuizBank : [];

  if (!root || !bank.length) return;

  var storageKey = 'ccRoyalMarinesKnowledgeQuiz';
  var intro = root.querySelector('.ccrh-quiz__intro');
  var stage = root.querySelector('[data-quiz-stage]');
  var result = root.querySelector('[data-quiz-result]');
  var startButton = root.querySelector('[data-quiz-start]');
  var restartButton = root.querySelector('[data-quiz-restart]');
  var checkButton = root.querySelector('[data-quiz-check]');
  var nextButton = root.querySelector('[data-quiz-next]');
  var bankCount = root.querySelector('[data-quiz-bank-count]');
  var bestScore = root.querySelector('[data-quiz-best]');
  var progress = root.querySelector('[data-quiz-progress]');
  var scoreText = root.querySelector('[data-quiz-score]');
  var progressBar = root.querySelector('[data-quiz-progress-bar]');
  var category = root.querySelector('[data-quiz-category]');
  var question = root.querySelector('[data-quiz-question]');
  var answers = root.querySelector('[data-quiz-answers]');
  var error = root.querySelector('[data-quiz-error]');
  var feedback = root.querySelector('[data-quiz-feedback]');
  var feedbackTitle = root.querySelector('[data-quiz-feedback-title]');
  var explanation = root.querySelector('[data-quiz-explanation]');
  var source = root.querySelector('[data-quiz-source]');
  var finalScore = root.querySelector('[data-quiz-final-score]');
  var resultTitle = root.querySelector('[data-quiz-result-title]');
  var resultCopy = root.querySelector('[data-quiz-result-copy]');

  var test = [];
  var currentIndex = 0;
  var score = 0;
  var answerChecked = false;

  function shuffle(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temporary = copy[i];
      copy[i] = copy[j];
      copy[j] = temporary;
    }
    return copy;
  }

  function getStoredProgress() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
      return {
        best: Number.isFinite(stored.best) ? stored.best : 0,
        attempts: Number.isFinite(stored.attempts) ? stored.attempts : 0
      };
    } catch (storageError) {
      return { best: 0, attempts: 0 };
    }
  }

  function saveProgress(finalResult) {
    var stored = getStoredProgress();
    var updated = {
      best: Math.max(stored.best, finalResult),
      attempts: stored.attempts + 1
    };

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(updated));
    } catch (storageError) {
      // The quiz still works when private browsing blocks local storage.
    }

    updateBestScore(updated.best);
  }

  function updateBestScore(value) {
    bestScore.textContent = value > 0 ? value + '/10' : '—';
  }

  function createTest() {
    var groups = bank.reduce(function (grouped, item) {
      if (!grouped[item.category]) grouped[item.category] = [];
      grouped[item.category].push(item);
      return grouped;
    }, {});

    var selected = Object.keys(groups).map(function (groupName) {
      var group = groups[groupName];
      return group[Math.floor(Math.random() * group.length)];
    });

    return shuffle(selected).slice(0, 10).map(function (item) {
      return {
        id: item.id,
        category: item.category,
        question: item.question,
        answer: item.answer,
        options: shuffle([item.answer].concat(item.distractors)),
        explanation: item.explanation,
        source: item.source
      };
    });
  }

  function renderQuestion() {
    var item = test[currentIndex];
    answerChecked = false;
    error.textContent = '';
    feedback.hidden = true;
    checkButton.hidden = false;
    checkButton.disabled = false;
    nextButton.textContent = currentIndex === test.length - 1 ? 'See result' : 'Next question';
    progress.textContent = 'Question ' + (currentIndex + 1) + ' of ' + test.length;
    scoreText.textContent = 'Score ' + score;
    progressBar.style.width = ((currentIndex + 1) / test.length) * 100 + '%';
    category.textContent = item.category;
    question.textContent = item.question;
    answers.replaceChildren();

    item.options.forEach(function (option, optionIndex) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      var text = document.createElement('span');
      var inputId = 'ccrh-answer-' + currentIndex + '-' + optionIndex;

      label.className = 'ccrh-answer';
      input.type = 'radio';
      input.name = 'ccrh-answer';
      input.id = inputId;
      input.value = option;
      text.textContent = option;
      label.setAttribute('for', inputId);
      label.appendChild(input);
      label.appendChild(text);
      answers.appendChild(label);
    });

    var firstAnswer = answers.querySelector('input');
    if (firstAnswer) firstAnswer.focus();
  }

  function startTest() {
    test = createTest();
    currentIndex = 0;
    score = 0;
    intro.hidden = true;
    result.hidden = true;
    stage.hidden = false;
    renderQuestion();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function checkAnswer() {
    if (answerChecked) return;

    var selected = answers.querySelector('input:checked');
    if (!selected) {
      error.textContent = 'Choose an answer before checking it.';
      return;
    }

    var item = test[currentIndex];
    var correct = selected.value === item.answer;
    answerChecked = true;
    error.textContent = '';

    if (correct) score += 1;

    answers.querySelectorAll('.ccrh-answer').forEach(function (label) {
      var input = label.querySelector('input');
      input.disabled = true;
      if (input.value === item.answer) label.dataset.state = 'correct';
      if (input.checked && !correct) label.dataset.state = 'incorrect';
    });

    scoreText.textContent = 'Score ' + score;
    feedbackTitle.textContent = correct ? 'Correct.' : 'Not quite. The correct answer is ' + item.answer + '.';
    explanation.textContent = item.explanation;
    source.href = item.source;
    feedback.hidden = false;
    checkButton.hidden = true;
    nextButton.focus();
  }

  function getResultMessage(finalResult) {
    if (finalResult === 10) {
      return {
        title: 'Exceptional candidate knowledge.',
        copy: 'You scored full marks across the complete subject mix. Keep checking current candidate instructions as the joining process can change.'
      };
    }
    if (finalResult >= 8) {
      return {
        title: 'Strong candidate knowledge.',
        copy: 'You have a strong grasp of the Corps, its history and the current joining route. Review the questions you missed, then take a fresh test.'
      };
    }
    if (finalResult >= 6) {
      return {
        title: 'A solid base.',
        copy: 'You know the essentials. Use the guide and official sources to strengthen the gaps before your interview or course.'
      };
    }
    return {
      title: 'Build the foundation.',
      copy: 'Work through the joining, training, units and history sections above, then return for a different ten-question test.'
    };
  }

  function showResult() {
    var message = getResultMessage(score);
    saveProgress(score);
    stage.hidden = true;
    result.hidden = false;
    finalScore.textContent = score + '/10';
    resultTitle.textContent = message.title;
    resultCopy.textContent = message.copy;
    restartButton.focus();
  }

  function nextQuestion() {
    if (!answerChecked) return;
    if (currentIndex === test.length - 1) {
      showResult();
      return;
    }
    currentIndex += 1;
    renderQuestion();
  }

  bankCount.textContent = String(bank.length);
  updateBestScore(getStoredProgress().best);
  startButton.addEventListener('click', startTest);
  restartButton.addEventListener('click', startTest);
  checkButton.addEventListener('click', checkAnswer);
  nextButton.addEventListener('click', nextQuestion);
}());
